export default "__VITE_ASSET__CrI$1CSa__"